import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useEffect, useRef } from 'react';
import { useIsLoggedIn } from '~/context/common/UserContext';
import InventoryContext from '~/context/srp/InventoryContext';
import { logError } from '~/utilities/loggers';

// resets inventory pricing on log in or log out so we refetch pricing
const useResetInventoryPricing = (vehicleIds: number[]) => {
  const isLoggedIn = useIsLoggedIn();
  const { resetInventoryPricing } = useContext(InventoryContext);
  const vehicleIdsRef = useRef(vehicleIds);
  useEffect(() => {
    vehicleIdsRef.current = vehicleIds;
  }, [vehicleIds]);

  useSubsequentEffect(() => {
    if (vehicleIdsRef.current.length === 0) return;

    try {
      resetInventoryPricing();
    } catch (err) {
      logError(err, { location: 'Pricing reset' });
    }
  }, [isLoggedIn, resetInventoryPricing]);
};

export default useResetInventoryPricing;
